import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { AppSettings } from '../../../../src/app/app.settings';
import { Settings } from '../../../../src/app/app.settings.model';

@Component({
    selector: 'loader-component',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class LoaderComponent implements OnInit {
    public settings: Settings;
    loaderColor = '';
    constructor(
        private appSettings: AppSettings,
    ) {
        this.settings = this.appSettings.settings;
    }

    ngOnInit() {
        this.settings.emitters.needReloadDashboard.subscribe(() => {
            this.colors();
        });

        this.colors();
    }

    public colors() {

        switch (this.settings.theme.skin) {
            case "greyDark":
            case "greyLight":
                this.loaderColor = 'loaderGrey';
                break;
            case "greenMusgo":
                this.loaderColor = 'loaderGreenMusgo';
                break;
            default:
                this.loaderColor = 'loaderSw';
                break;
        }
    }
}
